// extracted by mini-css-extract-plugin
export default {"description":"TransactionNaturesIndex_description__MjBqj"};